var React = require('react');

function PauseRegular (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M192 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm-48 346V85c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6zM448 79v352c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm-48 346V85c0-3.3-2.7-6-6-6h-84c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6z"}));
}

PauseRegular.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"far","data-icon":"pause","className":"svg-inline--fa fa-pause fa-w-14","role":"img","viewBox":"0 0 448 512"};

module.exports = PauseRegular;

PauseRegular.default = PauseRegular;
